import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../commonMeta";

export interface IStatesDataTableRowFormMeta {
    stateParameter: FormInputMeta;
    defaultValue: FormInputMeta;
    value: FormInputMeta;

    schema: any;
}

const statesDataTableRowFormMeta = {} as IStatesDataTableRowFormMeta;

statesDataTableRowFormMeta.stateParameter = {
  name: "stateParameter",
  type: "text",
  label: "State Parameter",
  placeholder: "Veuillez entrer le Paramètre état svp...",
  validation: yup.string().required(),
};

statesDataTableRowFormMeta.defaultValue = {
  name: "defaultValue",
  type: "text",
  label: "Default Value",
  placeholder: "Veuillez entrer la valeur par défaut svp...",
  validation: yup.string().required(),
};

statesDataTableRowFormMeta.value = {
  name: "value",
  type: "text",
  label: "Value",
  placeholder: "Veuillez entrer la valeur par défaut svp...",
  validation: yup.string().required(),
};


statesDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(statesDataTableRowFormMeta));

export default statesDataTableRowFormMeta;